export const styleSheet = theme => ({
    container: {
        // You probably can remove this
        backgroundColor: theme.colors.white02,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 8,
        marginRight: 6,
        borderRadius: 8,
        overflow: 'hidden',
        iframe: {
            flex: 1
        }
    },
    loading: {
        backgroundColor: theme.colors.white02,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8,
        marginRight: 6,
        borderRadius: 8,
        overflow: 'hidden'
    }
});
